/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

export const colors = {
  primary: '#ef6461',
  antdHover: '#fc9590',
  secondary: '#000000',
  terciary: '#0c6291',
  softGreen: '#60d394',
  malachite: '#1cc54e',
  tomato: '#c91432',
  appleBlossom: '#a74644',
  macaroniCheese: '#f9c22e',
  darkSkyBlue: '#30bced',
  fairPink: '#ffecec',
  deepLavender: '#9448bc',
  white: '#fff',
  alabaster: '#fafafa',
  lightGrey: '#f2f2f2',
  mediumGrey: '#d5d5d5',
  darkGrey: '#757575',
  primary_15: 'rgba(239, 100, 97, 0.15)',
  primary_85: 'rgba(239, 100, 97, 0.85)',
  lime: '#1cc54e'
};

export const sizes = {
  nano: '8px',
  mili: '10px',
  centi: '12px',
  deci: '14px',
  base: '16px',
  deka: '18px',
  hecto: '20px',
  kilo: '24px',
  mega: '26px',
  giga: '30px',
  tera: '32px',
  peta: '36px',
  exa: '40px',
  common: '45px',
  zetta: '64px',
  yotta: '72px'
};

// metric system prefixes:
// yotta, zetta, exa, peta, tera, giga, mega, kilo, hecto, deka, base, deci, centi, mili, micro, nano, pico, femto, atto, zepto, yocto

export const lineH = {
  base: 'normal',
  tiny: '1.10',
  small: '1.35',
  medium: '1.45'
};

export const borders = {
  lightGrey: `1px solid ${colors.lightGrey}`,
  midGrey: `1px solid ${colors.mediumGrey}`,
  darkGrey: `1px solid ${colors.darkGrey}`
};

export const borderRadius = '5px';

export const shadows = {
  lighterBlack: '0 2px 4px 0 rgba(0, 0, 0, 0.1)', // selects
  lightBlack: '0 2px 6px 0 rgba(0, 0, 0, 0.25)', // tabs
  black: '0 2px 14px 0 rgba(0, 0, 0, 0.4)',
  darkBlack: '0 4px 8px 0 rgba(0, 0, 0, 0.2)', // login - register
  darkerBlack: '0 2px 4px 0 rgba(0, 0, 0, 0.5)', // main
  lighterGray: '0 2px 5px 2px rgba(176, 176, 176, 0.25)' // cards
};

export const opacity = {
  min: '0.1',
  two: '0.2',
  medium: '0.5',
  max: '1'
};

export const transitions = {
  base: 'all .2s ease-in-out',
  fade: 'opacity .15s linear',
  collapse: 'height .35s ease'
};

export const theme = {
  fontFamily: {
    sansSerif: '"Source Sans Pro", Arial, sans-serif'
  },
  colors: {
    text: `${colors.secondary}`,
    background: `${colors.alabaster}`,
    backgroundCard: `${colors.white}`,
    main: `${colors.darkSkyBlue}`,
    linkHover: `${colors.linkGradient}`,
    border: `${borders.midGrey}`,
    shadow: `${shadows.black}`,
    accentPositive: `${colors.malachite}`,
    accentNegative: `${colors.tomato}`,
    accentInformative: `${colors.macaroniCheese}`
  }
};
